import React from "react";
import "./Cloud9MatrixModal.css";

const Cloud9MatrixModal = ({ open, onClose, groupData = [] }) => {
  if (!open) return null;
const calculateAnnual = (monthly) => {
    if (!monthly || monthly <= 0) {
      return {
        annualTotal: "0.00",
        discountPercent: "0",
      };
    }

    const fullAnnual = monthly * 12;
    const discounted = monthly * 11;
    const saved = fullAnnual - discounted;
    const percent = ((saved / fullAnnual) * 100).toFixed(0);

    return {
      annualTotal: discounted.toFixed(2),
      discountPercent: percent,
    };
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>🌤️ Cloud 9 Group / Plan Reference</h3>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>

        <table className="plan-table">
          <thead>
            <tr>
              <th>Group ID</th>
              <th>Plan</th>
              <th>Description</th>
              <th>Fee</th>
              <th>Text Limit</th>
              <th>Media Limit</th>
              <th>Edit Window</th>
              <th>Priority</th>
            </tr>
          </thead>

          <tbody>
            {groupData.map((group) => {
              const isPaid = group.id >= 6 && group.id <= 9;
              const monthly = parseFloat(group.subscriptionFee || 0);

              const { annualTotal, discountPercent } = calculateAnnual(monthly);

              return (
                <tr key={group.id}>
                  <td className="align-top">{group.id}</td>
                  <td className="align-top">{group.name}</td>
                  <td className="align-top">{group.description}</td>

                  <td className="align-top">
                    <div className="fee-main">
                      CAD ${monthly.toFixed(2)} / mo
                    </div>

                    {isPaid && (
                      <div className="fee-sub">
                        CAD ${annualTotal} / yr — Save {discountPercent}%
                      </div>
                    )}
                  </td>

                  <td>{group.postLimit} chars</td>
                  <td>{group.mediaLimit} KB</td>
                  <td>{group.editTimeout} min</td>
                  <td>{group.priorityBoost ? "✅" : "—"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Cloud9MatrixModal;